import { render, staticRenderFns } from "./ActDetails.vue?vue&type=template&id=8089372a"
import script from "./ActDetails.vue?vue&type=script&lang=js"
export * from "./ActDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports